import React, { Component } from 'react';

// Config del conteo cíclico, por sucursal seleccionada. Vive en Configuración > Conteo.
const config = process.env;
const apiBase = () => config.REACT_APP_BASE_URL + config.REACT_APP_VERSION;
const authHeaders = () => ({
    'access-token': localStorage.getItem('token'),
    'Content-Type': 'application/json',
});

class StockCountSettingsComponent extends Component {
    constructor() {
        super();
        this.state = {
            config: { itemsPerDay: 20, recentSalesWindowDays: 7, coverageWindowDays: 30, countEnabled: false },
            catalogTotal: null,
            loading: true,
            saved: false,
        };
    }

    async componentDidMount() {
        await this.load();
    }

    fetchJson = async (path, options) => {
        const res = await fetch(apiBase() + path, { headers: authHeaders(), ...options });
        return res.json();
    }

    load = async () => {
        const [cfg, cov] = await Promise.all([
            this.fetchJson('stock/config', { method: 'GET' }),
            this.fetchJson('stock/coverage', { method: 'GET' }),
        ]);
        this.setState((s) => ({
            config: cfg.error === 0 ? cfg.data : s.config,
            catalogTotal: cov.error === 0 ? cov.data.total : null,
            loading: false,
        }));
    }

    setCfg = (key, value) => this.setState((s) => ({ config: { ...s.config, [key]: value }, saved: false }));

    save = async () => {
        const c = this.state.config;
        const body = await this.fetchJson('stock/config', {
            method: 'PUT',
            body: JSON.stringify({
                items_per_day: c.itemsPerDay,
                recent_sales_window_days: c.recentSalesWindowDays,
                coverage_window_days: c.coverageWindowDays,
                count_enabled: c.countEnabled,
            }),
        });
        if (body.error === 0) this.setState({ config: body.data, saved: true });
    }

    render() {
        const c = this.state.config;
        const suggested = this.state.catalogTotal
            ? Math.ceil(this.state.catalogTotal / (c.coverageWindowDays || 30))
            : null;
        if (this.state.loading) {
            return <p>Cargando…</p>;
        }
        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom"><h6 className="m-0">Conteo cíclico de inventario</h6></div>
                <div className="card-body">
                    <p className="text-muted">Parámetros de la sucursal seleccionada.</p>
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Ítems por día</label>
                            <input type="number" min="1" className="form-control" value={c.itemsPerDay}
                                onChange={(e) => this.setCfg('itemsPerDay', Number(e.target.value))} />
                            {suggested && (
                                <small className="form-text text-muted">
                                    Sugerido ~{suggested}/día (cubre {this.state.catalogTotal} productos en {c.coverageWindowDays} días).{' '}
                                    <button type="button" className="btn btn-link btn-sm p-0 align-baseline"
                                        onClick={() => this.setCfg('itemsPerDay', suggested)}>Usar sugerido</button>
                                </small>
                            )}
                        </div>
                        <div className="form-group col-md-3">
                            <label>Ventana de ventas (días)</label>
                            <input type="number" min="1" className="form-control" value={c.recentSalesWindowDays}
                                onChange={(e) => this.setCfg('recentSalesWindowDays', Number(e.target.value))} />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Ventana de cobertura (días)</label>
                            <input type="number" min="1" className="form-control" value={c.coverageWindowDays}
                                onChange={(e) => this.setCfg('coverageWindowDays', Number(e.target.value))} />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Conteo activo en esta sucursal</label>
                            <div>
                                <label className="mt-1">
                                    <input type="checkbox" checked={!!c.countEnabled}
                                        onChange={(e) => this.setCfg('countEnabled', e.target.checked)} /> {c.countEnabled ? 'Sí' : 'No'}
                                </label>
                            </div>
                        </div>
                    </div>
                    <button type="button" className="btn btn-primary" onClick={this.save}>Guardar</button>
                    {this.state.saved && <span className="text-success ml-2">Guardado ✓</span>}
                </div>
            </div>
        );
    }
}

export default StockCountSettingsComponent;
